import React from "react";
import classNames from "classnames";

import Button from "../../button/Button";

import { AccountSubHeaderProps } from "../types";
import styles from "./accountSubHeader.module.css";

const AccountSubHeader = ({
  title,
  withBorder = true,
  children,
}: AccountSubHeaderProps): JSX.Element => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.withBorder]: withBorder,
      })}
    >
      <h3 className={styles.title}>{title}</h3>
      <div>{children}</div>
    </div>
  );
};

export default AccountSubHeader;
